module.exports = __webpack_public_path__ + "Project.fabc4041a63dd92956ce844910e7e28a.hashedasset.svg";